<template>
    <v-data-table
        v-bind="{
            items,
            headers,
            itemsPerPage: -1,
            itemClass: (item) => (item.isGained ? 'is-gained--true' : 'is-gained--false'),
        }"
        hide-default-footer
        disable-pagination
        disable-sort
        class="nshop-order-view-pins"
    >
        <template v-for="(header, index) in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> <span :key="index" v-html="header.formatter.bind(item)(value, item)" /> </template>
    </v-data-table>
</template>

<script>
import { initDataTableHeaders } from "@/assets/lib";
import { initNshopOrder } from "@/store/nshop";

export default {
    props: {
        value: { type: Object, default: initNshopOrder },
        dense: { type: Boolean, default: false },
    },
    data: () => ({}),
    computed: {
        /** @returns {import('@/store/nshop').NshopOrder_Pin[]} */
        items() {
            return this.value.pins;
        },
        headers() {
            return initDataTableHeaders([
                {
                    text: "권종",
                    value: "faceamt",
                    align: "center",
                    width: 180,
                    formatterType: "number",
                    formatterPrefix: "나누리상품권",
                    formatterSuffix: "원권",
                },
                {
                    text: "상품권 번호",
                    value: "pno",
                    align: "center",
                    width: 200,
                },
                {
                    text: "상태",
                    value: "isGained",
                    align: "center",
                    width: +80,
                    formatter: (value) => (value ? "사용완료" : "사용대기"),
                    cellClass: "is-gained",
                },
                {
                    text: "발권일시",
                    value: "issuedAt",
                    align: "center",
                    width: 170,
                    formatterType: "datetime",
                    shows: !this.dense,
                },
                {
                    text: "만료일시",
                    value: "expiredAt",
                    align: "center",
                    width: 170,
                    formatterType: "datetime",
                    shows: !this.dense,
                },
            ]);
        },
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.nshop-order-view-pins {
    &,
    ::v-deep *,
    ::v-deep td {
        font-size: 14px !important;
        line-height: 1.25 !important;
    }

    & ::v-deep tr.is-gained {
        &--false {
            & td.is-gained {
                font-weight: bold;
                color: var(--v-primary-base) !important;
            }
        }

        &--true {
            text-decoration: line-through;
        }
    }
}
</style>
